import {
  bynderImageProjection,
  compactBynderImageProjection,
  compatibleImageProjection,
  spreadBynderImageProjection,
} from '@workspace/sanity-base/queries/projection';

/**
 * Re-exported for this app's query files. Imported unaliased on purpose: Sanity typegen
 * cannot follow an aliased import or a re-export across workspace packages.
 * See packages/sanity-base/queries/projection.ts for the rules these helpers must obey.
 */
export { bynderImageProjection, compatibleImageProjection, spreadBynderImageProjection };

import { namespaceType } from './namespace';

const productsListType = namespaceType('productsList');
const productType = namespaceType('product');
const structaProductLevel1Type = namespaceType('structaProductLevel1');
const articlesListType = namespaceType('articlesList');
const articleType = namespaceType('article');
const documentPageType = namespaceType('documentPage');
const faqsType = namespaceType('faqs');
const contactUsType = namespaceType('contactUs');
const storeLocatorType = namespaceType('storeLocator');
const homePageType = namespaceType('homePage');

export const computedInternalUrl = `
  select(
    defined(parentPage->parentPage->slug.current) => "/products/" + parentPage->parentPage->slug.current + "/" + parentPage->slug.current + "/" + slug.current,
    defined(parentPage->slug.current) => "/products/" + parentPage->slug.current + "/" + slug.current,
    _type == "${productsListType}" => "/products/" + category->slug.current + "/" + slug.current,
    _type == "${productType}" && defined(subcategory->parentCategory->slug.current) => "/products/" + subcategory->parentCategory->slug.current + "/" + subcategory->slug.current + "/" + slug.current,
    _type == "${structaProductLevel1Type}" => "/products/" + slug.current,
    _type == "${articlesListType}" => "/" + select(
      type == "blogs" => "blog",
      type
    ),
    _type == "${articleType}" && defined(type) && type == "blogs" => "/blog/" + slug.current,
    _type == "${articleType}" && defined(type) => "/" + type + "/" + slug.current,
    _type == "${documentPageType}" => "/documents/" + slug.current,
    _type == "${faqsType}" => "/faq",
    _type == "${contactUsType}" => "/contact-us",
    _type == "${storeLocatorType}" => "/store-locator",
    _type == "${homePageType}" => "/",
    "/" + slug.current
  )
`;

export const internalReferenceUrl = `
  select(
    type == "internal" =>
      internalReference->{
        "computedUrl": ${computedInternalUrl}
      }.computedUrl,
    url
  )
`;

export const directInternalReferenceUrl = `
  select(
    link.type == "internal" =>
      link.internalReference->{
        "computedUrl": ${computedInternalUrl}
      }.computedUrl,
    link.type == "external" => link.url
  )
`;

export const bynderImageUrl = (field: string) => `
  coalesce(
    ${field}.selectedUrl,
    ${field}.url,
    ${field}.datUrl,
    ${field}.previewUrl,
    ${field}.previewImg
  )
`;


export const LOGO_PROJECTTION = `
  {
    ...logo,
    "bynderLogo": ${compactBynderImageProjection('logo.bynderLogo')},
    "link": logo.link{
      ...,
      "url": ${internalReferenceUrl},
    },
    "imageUrl": ${bynderImageUrl('logo.bynderLogo')},
  }
`;

